import { DataRequestProject } from '../models/DataRequestHub/DataRequestProject';
import { ProjectProgressStatus } from '../models/DataRequestHub/ProjectProgressStatusEnum copy';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { useCurrentMarketplaceParty } from './useCurrentMarketplaceParty';
import { useStateSelector } from '../store/selectors';

export const useIsDataRequestProjectReadonly = (
    projects: DataRequestProject[],
    engagementId?: number
): boolean => {
    const currentTimeline = useStateSelector(
        (s) => s.timelines.currentTimeline
    );
    const effectiveEngagementId = engagementId ?? currentTimeline?.id;
    const isReadonlyForExternalUsers =
        useCurrentMarketplaceParty(effectiveEngagementId) === TimelineParty.Broker;
    return (
        (projects.length > 0 &&
            projects.every(
                (project) =>
                    project?.isExternalProject &&
                    project?.status === ProjectProgressStatus.Complete
            )) ||
        isReadonlyForExternalUsers
    );
};
